export default __webpack_public_path__ + "static/media/shoes14.5f2e770c.jpeg";